module.exports = __webpack_public_path__ + "img/copPerDegree2.b2e8b482.png";